import React, { useContext } from "react";
import { Grid, Typography, Box, Container } from "@mui/material";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ThemeContext } from "../../../themeContext";

const ProjectHero = () => {
  const { mode } = useContext(ThemeContext);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const boxVariants = {
    hidden: { y: 100, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: 6 }}>
      <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={boxVariants}
        style={{ width: "100%" }}
      >
        <Box sx={{ width: "100%" }}>
          <Grid
            container
            spacing={6}
            alignItems="center"
            justifyContent="center"
            sx={{ width: "100%" }}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  p: 2,
                }}
              >
                <Box
                  component="img"
                  src={
                    mode === "dark"
                      ? "/images/projects/project-board-dark.webp"
                      : "/images/projects/project-board-light.webp"
                  }
                  alt="Education Placeholder"
                  sx={{
                    width: "350px",
                    height: "auto",
                    borderRadius: 2,
                    boxShadow: 3,
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  p: 2,
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    mb: 2,
                  }}
                >
                  Projects
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    textAlign: "center",
                    fontWeight: "medium",
                    maxWidth: "630px",
                  }}
                >
                  My projects incorporate a wide range of modern technologies,
                  combining full-stack development with thoughtful UI/UX design.
                  I specialize in building and deploying dynamic web
                  applications using the MERN stack, with seamless integration
                  of front-end interfaces and backend functionality. I also have
                  experience deploying these applications to the cloud for
                  scalability and performance.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </motion.div>
    </Container>
  );
};

export default ProjectHero;
